import React from 'react'
import TextField from '@mui/material/TextField'
// import DatePicker from '../../../CommonComponents/DatePickerMUI'
const Disburse = ({ amount, amountHandler, disburseHandler, close, disburseDate, disburseDateHandler }) => {
    return (
        <div className="background-blur-admin" >
            <div className="popup-admin text-center">
                <i className='fa fa-close' onClick={() => close()} style={{ float: 'right', color: 'red', marginTop: '-20px', cursor: 'pointer' }}></i>
                <div className='row' style={{ marginTop: '20px' }}>
                    <TextField
                        label="Amount"
                        variant="outlined"
                        value={amount}
                        type="number"
                        onChange={e => amountHandler(e)}
                        size="small"
                        style={{ width: '100%' }}
                    />
                </div>
                <div className='row' style={{ marginTop: '20px' }}>
                    {/* <DatePicker
                        label="Disbursed Date"
                        // format={'MM/dd/yyyy'}
                        value={disburseDate}
                        name="disburseDate"
                        size="small"
                        onChange={(e) => disburseDateHandler(e)}
                        required={true}
                    /> */}
                    <TextField
                        type='date'
                        required={true}
                        label="Disbursed Date"
                        value={disburseDate}
                        name="disburseDate"
                        variant="outlined"
                        size="small"
                        onChange={(e) => disburseDateHandler(e)}
                    />
                </div>

                <div className='mt-5 row'>
                    <div className="col-12 text-center">
                        <button className="cred-btn" onClick={e => disburseHandler()}>Submit</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Disburse